import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { View, Image, Button } from '@zhike/ti-ui';
import axios from 'axios';
import { get } from 'lodash';
import { getTelAttribution } from 'common/apis';
import styles from './styles';

// 渲染雷达图组件

export default class Project extends Component {
  // 参数
  static propTypes = {
    grade: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
    score: PropTypes.string.isRequired,
    examId: PropTypes.number.isRequired,
  };
  // 参数
  static defaultProps = {
  };
  // 构造函数
  constructor(props) {
    super(props);
    this.state = {
      address: '线上',
    };
  }
  async componentDidMount() {
    await this.getProjectInfo(this.props);
  }
  async componentWillReceiveProps(nextProps) {
    if (this.props.phone !== nextProps.phone || this.props.grade !== nextProps.grade) {
      await this.getProjectInfo(nextProps);
    }
  }

  // 设置用户出国留学信息
  async getProjectInfo(props) {
    const { phone, grade } = props;
    const tel = [];
    tel.push(phone);
    const message = await axios({
      url: getTelAttribution[1],
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        From: 1,
      },
      data: {
        tel,
      },
    });
    // 设置用户地址
    let address;
    const city = get(message, `data.${tel}.city`);
    const gradeArr = ['初中', '高一', '高二', '高三'];
    const centerCities = ['北京', '天津', '长春', '上海', '杭州', '深圳', '广州', '成都'];
    if (gradeArr.indexOf(grade) !== -1 && centerCities.indexOf(city) !== -1) {
      address = '中心';
    } else {
      address = '线上';
    }
    this.setState({ address });
  }

  render() {
    const { examId, grade, score } = this.props;
    const { address } = this.state;
    return (
      <View className={styles.projectForTest}>
        <View className={styles.projectTitle}>为你推荐</View>
        <View className={styles.projectBg}>
          <View className={styles.projectTitle1}>你的备考规划已经生成！</View>
          <View className={styles.projectText}>为你量身定制的留学备考方案，点击查看详细内容</View>
          <Button
            className={styles.button}
            textClassName={styles.buttonText}
            text="立即查看"
            onClick={() => {
              global.window.open(`https://media8.smartstudy.com/tiku/planning/${examId === 1 ? '托福' : '雅思'}-${address}/${examId === 1 ? '托福' : '雅思'}-${address}-${grade}${score ? `-${score}` : ''}.png`);
            }}
          />
          <Image
            src={`https://media8.smartstudy.com/tiku/planning/${examId === 1 ? '托福' : '雅思'}-${address}/${examId === 1 ? '托福' : '雅思'}-${address}-${grade}${score ? `-${score}` : ''}.png`}
            style={{ marginTop: '50px', width: '920px', border: '1px solid gray', cursor: 'pointer' }}
            onClick={() => {
              global.window.open(`https://media8.smartstudy.com/tiku/planning/${examId === 1 ? '托福' : '雅思'}-${address}/${examId === 1 ? '托福' : '雅思'}-${address}-${grade}${score ? `-${score}` : ''}.png`);
            }}
          />
        </View>
      </View>);
  }
}




// WEBPACK FOOTER //
// ./src/components/report/evaluation_report/common/project/index.js